var _ = require("lodash");
var defaults = require("./default.js");
var config = require("./" + (process.env.REACT_APP_NODE_ENV || "development") + ".js");
module.exports = _.merge({}, defaults, config);